<div class="container d-flex flex-column">
    <div class="heading-div d-flex justify-content-between">
        <span class="fc-content">Add Your Oblate</span>
        <div class="img-div" (click)="closeDialog()">
            <img alt="cross" class="img-cross" src="../../../assets/images/cross_white.svg" />
        </div>
    </div>
</div>

<div class="diksha-btn-row">
    <div class="btn-div">
    @if(isAbleToAddDPOnline){
    <button type="button" class="dp-secondary-btn ibtn" (click)="onClickAddOblate('online')"
        (mouseenter)="showOnlineMessage = true" (mouseleave)="showOnlineMessage = false">
        <mat-icon fontIcon="person_add"></mat-icon>
        <span class="textContent">New diksha (Online)</span>

    </button>
    }

    @if(isAbleToAddDPOffline){
    <button type="button" class="dp-secondary-btn ibtn" (click)="onClickAddOblate('offline')"
        (mouseenter)="showOfflineMessage = true" (mouseleave)="showOfflineMessage = false">
        <mat-icon fontIcon="person_add"></mat-icon>
        <span class="textContent">Upload DP (Offline)</span>
    </button>
    }
    </div>

    <div class="btn-div">
    @if(isAbleToAddSPOnline){
    <button type="button" class="dp-secondary-btn ibtn" (click)="onClickAddOblate('sp_online')"
        (mouseenter)="showSpOnlineMessage = true" (mouseleave)="showSpOnlineMessage = false">
        <mat-icon fontIcon="person_add"></mat-icon>
        <span class="textContent">New Swastayani(Online)</span>
    </button>
    }

    @if(isAbleToAddSPOffline){
    <button type="button" class="dp-secondary-btn ibtn" (click)="onClickAddOblate('sp_offline')"
        (mouseenter)="showSpOfflineMessage = true" (mouseleave)="showSpOfflineMessage = false">
        <mat-icon fontIcon="person_add"></mat-icon>
        <span class="textContent">Upload SP(Offline)</span>
    </button>
    }
    </div>

    @if (showOnlineMessage) {
    <div class="add-oblate-description">This method is only applicable for real-time initiations. Please check
        before proceeding!</div>
    }

    @if (showOfflineMessage) {
    <div class="add-oblate-description">This method is to upload diksha patras of the ongoing term.</div>
    }

    @if (showSpOnlineMessage) {
    <div class="add-oblate-description">This method is only applicable for real-time swastayani. Please check
        before proceeding!</div>
    }

    @if (showSpOfflineMessage) {
    <div class="add-oblate-description">This method is to upload swastayani patras of the ongoing term.</div>
    }
</div>